/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-control-plaintext[_ngcontent-%COMP%]{padding:0;font-weight:700;margin-top:-.25rem}ul[_ngcontent-%COMP%]{padding-left:1rem;list-style-position:inside}"];
export { styles as styles };
